import React from 'react';
import { Select, message } from 'antd';
import { useTranslation } from 'react-i18next';
import { GlobalOutlined } from '@ant-design/icons';
import { useAuthStore } from '../store/authStore';
import api from '../utils/api';

const { Option } = Select;

const LanguageSwitcher = () => {
    const { i18n } = useTranslation();
    const { user, updateUser } = useAuthStore();

    const changeLanguage = async (lng) => {
        i18n.changeLanguage(lng);
        // Update document direction
        document.documentElement.dir = lng === 'en' ? 'ltr' : 'rtl';
        document.documentElement.lang = lng;

        // Save to user preferences if authenticated
        if (user) {
            try {
                await api.put('/auth/update-language', { language: lng });
                // Update user in store
                updateUser({ ...user, language: lng });
            } catch (error) {
                console.error('Failed to save language preference:', error);
                // Don't show error to user, language still works locally
            }
        }
    };

    return (
        <Select
            value={i18n.language}
            onChange={changeLanguage}
            style={{ width: 140 }}
            suffixIcon={<GlobalOutlined />}
        >
            <Option value="ku">کوردی</Option>
            <Option value="ar">العربية</Option>
            <Option value="en">English</Option>
        </Select>
    );
};

export default LanguageSwitcher;
